import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from '../reducers';
import useEffectOnce from '../hooks/useEffectOnce';
import { SUPRIVISOR_API } from '../ApiNames';
import {  getCountry, getcountryname, getState, gethcountryname } from '../reduxactions/suprivisoractions/SuprivisorProfileActions';
import { fetchDataAssistantProfile, UploadImageData  } from '../reduxactions/doctorapproveractions/AProfileActions';
import { Panel } from 'primereact/panel';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { LoginService } from '../services/LoginService';
import { SelectButton } from 'primereact/selectbutton';
import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
export const AssistantProfile = () => {
  const uid = window.sessionStorage.getItem('uid');

  const [globalFilter, setGlobalFilter] = useState('');
  const stepperRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(0);
  const options = ['Personal Info', 'Hospital Info'];
  const [value, setValue] = useState(options[0]);
  const dispatch = useDispatch();
    const data = useSelector((state: RootState) => state.assistantprofilerole.get);
  useEffectOnce(() => {
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchDataAssistantProfile(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    fetchDataAsync();
}, [dispatch]);
const image = useSelector((state: RootState) => state.assistantprofilerole.image);

  const [selectedFile, setselectedFile] = useState<File | null>(null);
  const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
      const files = event.files;
      if (files.length > 0) {
          const file = files[0];
          console.log("file:", file);
          setselectedFile(file);
          console.log("called image function:", file)
          try {
              await dispatch(UploadImageData(file, uid) as any);
          } catch (error) {
              console.error('Error uploading image:', error);
          }
      }

  };
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [address, setAddress] = useState('');

  const [hospitalName, setHospitalname] = useState('');
  const [hospitalPrefix, setprefix] = useState('');
  const [hemail, setHemail] = useState('');
  const [hphone, sethphone] = useState('');
  const [hcountry, sethcountry] = useState('');
  const [hstate, sethstate] = useState('');
  const [hcity, sethcity] = useState('');
  const [haddress, sethaddress] = useState('');
  const [pincode, sethpin] = useState('');
  const [hsptl, sethsptl] = useState('');
  const [pincodes,setPincode]=useState(''); 
 //To get data
//  const [data, setData] = useState<[]>([]);

 const fetchDataAsync = async () => {
  try {
      const payload = { uid: uid };
      const apiname = SUPRIVISOR_API.assistantprofile_API;
      const response = await LoginService.getData(apiname, payload);
      setFirstName(response[0].firstName);
      setLastname(response[0].lastName);
      setEmail(response[0].email);
      setPhone(response[0].phone);
      setCountry(response[0].country);
      setState(response[0].state);
      setCity(response[0].city);
      setAddress(response[0].address);
      setPincode(response[0].pin);
      setHospitalname(response[0].hospitalname)
      setprefix(response[0].hospitalprefix);
      setHemail(response[0].hemail);
      sethphone(response[0].hphone)
      sethcountry(response[0].hcountry)
      sethstate(response[0].hstate)
      sethcity(response[0].hcity)
      sethpin(response[0].hpincode);
      sethaddress(response[0].haddress);
      sethsptl(response[0].hsptl)


      const country = response[0].country;
      if (country && country.length > 0) {
          fetchstate(country);
          getcountryvalue(country);
      }
      const hcountry = response[0].hcountry;
      if (hcountry && country.length > 0) {
          gethcountryvalue(hcountry);
      }


  } catch (error) {
      console.error('Error fetching data:', error);
  }
};
    //get country state
    const countrydata = useSelector((state: RootState) => state.sprofile.country);
    const statedata = useSelector((state: RootState) => state.sprofile.state);
    const name = useSelector((state: RootState) => state.sprofile.name);
    const hcountryname = useSelector((state: RootState) => state.sprofile.hcountry);



    useEffectOnce(() => {
        const fetchcountry = async () => {
            try {
                await dispatch(getCountry() as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchcountry();
    }, [dispatch]);





    const getcountryvalue = async (country: any) => {
        try {
            await dispatch(getcountryname(country) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const gethcountryvalue = async (hcountry: any) => {
        try {
            await dispatch(gethcountryname(hcountry) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    const fetchstate = async (country: any) => {
        try {
            await dispatch(getState(country) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffectOnce(() => {
      fetchDataAsync();
     
  }, [dispatch]);

  const toast = useRef<Toast>(null);
  
  const updateProfilePersonal = async () => {
      try {
          const payload = {name:firstName,lname:lastName,email:email,phone: phone, address: address, city: city, country: country, state: state,pin:pincodes,filename:image,uid:uid};
          const apiname = '/ws_an_assprofile.php';
          const data = await LoginService.getData(apiname, payload);
          if (toast.current) {
              toast.current.show({ severity: 'success', detail: data });
          }
          fetchDataAsync();
      } catch (error) {
          console.error('Error fetching address data:', error);
      }
  };


  return (
    <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="grid">

                                {data.map((response: any) =>
                                    <div className="col-3">
                                        <Card header="" style={{ width: '300px', borderTop: '2px solid blue', marginTop: '74px' }}>
                                            <div
                                                className="widget-user-header bg-info"
                                                style={{ borderRadius: '10px 10px 0 0', position: 'relative', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

                                                <img
                                                    src={response.photo}
                                                    alt="User Avatar"
                                                    style={{
                                                        width: '110px',
                                                        height: '90px',
                                                        borderRadius: '50%',
                                                        position: 'absolute',
                                                        bottom: '-65px',
                                                        left: '50%',
                                                        padding: '3px',
                                                        backgroundColor: '#fff',
                                                        transform: 'translateX(-50%)',
                                                        border: '3px solid #adb5bd',

                                                    }}
                                                />
                                            </div>
                                            <h3
                                                className="widget-user-username"
                                                style={{
                                                    color: 'black',
                                                    fontSize: '25px',
                                                    fontWeight: '300',
                                                    marginTop: '70px'
                                                }}
                                            >
                                                {response.firstName}
                                            </h3>
                                            <h4
                                                className="widget-user-username"
                                                style={{
                                                    color: '#6c757d',
                                                    fontSize: '20px',
                                                    fontWeight: '300',
                                                    marginBottom: '20px',
                                                    marginTop: '10px'
                                                }}
                                            >
                                                Assistant
                                            </h4>
                                            <FileUpload mode="basic" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                                            {selectedFile && <p style={{ marginTop: '10px' }}>{selectedFile.name}</p>}



                                        </Card>
                                        



                                    </div>
                                )}
                                <div className='col-6' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <div className='col-12' >
                                        <SelectButton value={value} onChange={(e) => setValue(e.value)} options={options} allowEmpty={false} />
                                    </div>
                                </div >
                                <div className='col-3' >
                                    <div style={{ marginTop: '40px', marginLeft: '-565px' }}>
                                        <div className='col-2'></div>
                                        <div className='col-2'></div>
                                        {value == 'Personal Info' && (
                                            <div>
                                                <Card className="profile-header" style={{ width: '850px' }}>
                                                    <Panel header="Personal Info" toggleable>
                                                    <div style={{ width: '100%' }}>
                                                    </div>
                                                        <div className="grid">
                                                            <div className="col-12">


                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>FirstName:</label>
                                                                    <InputText id="nameoforg" type="text" placeholder="Enter Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                                                                </div>
                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>LastName:</label>
                                                                    <InputText id="nameoforg" type="text" placeholder="Enter Name" value={lastName} onChange={(e) => setLastname(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                                                                </div>

                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="email" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>E-Mail:</label>
                                                                    <InputText id="email" type="text"  placeholder="Enter E-mail" value={email} onChange={(e) => setEmail(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} disabled/>
                                                                </div>

                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="phone" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Phone Number:</label>
                                                                    <InputText id="phone" type="number" placeholder="Enter Phone Number" value={phone} onChange={(e) => { const value = e.target.value; if (/^\d{0,10}$/.test(value)) { setPhone(value); } }} style={{ flex: 1, marginLeft: '10px' }} />
                                                                </div>

                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="address" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Country:</label>

                                                                    <Dropdown id="country" value={country} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => { fetchstate(e.value); setCountry(e.value) }} options={countrydata} optionLabel="name" optionValue="id" placeholder="Select a Country" style={{ flex: 1, marginLeft: '10px' }} />
                                                                </div>

                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="zip" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>State:</label>
                                                                    <Dropdown id="state" value={state} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => setState(e.value)} options={statedata} optionLabel="name" optionValue="id" placeholder="Select a State" style={{ flex: 1, marginLeft: '10px' }} />
                                                                </div>

                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="country" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>City:</label>
                                                                    <InputText id="phone" type="text" placeholder="Enter City" value={city} onChange={(e) => setCity(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                                                                </div>

                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Address:</label>
                                                                    <InputText id="phone" type="text" placeholder="Enter Address" value={address} onChange={(e) => setAddress(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                                                                    
                                                                </div>
                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Pin Code:</label>
                                                                    <InputText id="phone" type="text" placeholder="Enter Pincode" value={pincodes} onChange={(e) => setPincode(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                                                                    
                                                                </div>
                                                               

                                                            </div>
                                                            <div className="card-footer">
                                                                <div className="flex justify-content-end" style={{ marginLeft: '150px' }}>
                                                                       
                                                                        <div style={{ width: '100px' }} className="mr-2"></div>
                                                                    
                                                                    <Button label="Submit" className="p-button-primary"  style={{ backgroundColor: '#2563eb' }} onClick={updateProfilePersonal} />
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </Panel>
                                                </Card>
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ display: 'flex', marginLeft: '-565px' }}>

                                        {value == 'Hospital Info' && (
                                            <div>
                                                <Card className="profile-header" style={{ width: '850px' }}>
                                                    <div className="grid">
                                                        <div className="col-12">


                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>HospitalName:</label>
                                                                <InputText id="nameoforg" type="text" placeholder="Enter Name" value={hospitalName} onChange={(e) => setHospitalname(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                                                            </div>
                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Hospital Prefix:</label>
                                                                <InputText id="nameoforg" type="text" placeholder="Enter Name" value={hospitalPrefix} onChange={(e) => setprefix(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="email" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>E-Mail:</label>
                                                                <InputText id="email" type="text" disabled placeholder="Enter E-mail" value={hemail} onChange={(e) => setHemail(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="phone" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Phone Number:</label>
                                                                <InputText id="phone" type="number" placeholder="Enter Phone Number" value={hphone} onChange={(e) => { const value = e.target.value; if (/^\d{0,10}$/.test(value)) { sethphone(value); } }} style={{ flex: 1, marginLeft: '10px' }} disabled/>

                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="address" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Country:</label>

                                                                <Dropdown id="country" value={hcountry} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => { fetchstate(e.value); sethcountry(e.value) }} options={countrydata} optionLabel="name" optionValue="id" placeholder="Select a Country" style={{ flex: 1, marginLeft: '10px' }} disabled/>
                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="zip" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>State:</label>
                                                                <Dropdown id="country" value={hstate} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => sethstate(e.value)} options={statedata} optionLabel="name" optionValue="id" placeholder="Select a State" style={{ flex: 1, marginLeft: '10px' }} disabled/>
                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="country" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>City:</label>
                                                                <InputText id="phone" type="text" placeholder="Enter City" value={hcity} onChange={(e) => sethcity(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} disabled/>
                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Address:</label>
                                                                <InputText id="phone" type="text" placeholder="Enter Address" value={haddress} onChange={(e) => sethaddress(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} disabled/>
                                                            </div>
                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Pincode:</label>
                                                                <InputText id="phone" type="text" placeholder="Enter pincode" value={pincode}  onChange={(e) => {const newValue = e.target.value;if (/^\d{0,6}$/.test(newValue)) {sethpin(newValue);}}} style={{ flex: 1, marginLeft: '10px' }} disabled/>
                                                            </div>
                                                        </div>                                                     

                                                    </div>
                                                </Card>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </section>
                    </div>
                </div>
                <Toast ref={toast} ></Toast>
            </div>
        </div>
  )
}